export const getDiscountedPrice = (price: number, currentDiscountAmount: number | undefined) => {
  const discount = currentDiscountAmount ? Math.round(price * currentDiscountAmount) / 100 : 0;
  return price - discount;
};
